require('./callers-table.style.less');
require('./callers-table-directive-template.html');

angular.module('bbl.dashboard.directive.callers-table', [
  'vs-repeat'
])
	.directive('callersTable', [function() {
		return {
			restrict: 'E',
			templateUrl: 'callers-table-directive-template.html',
			scope: {
				callers: '=',
				bridge: '=',
				user: '=',
				disableDrag: '=',
			},

			controller: ['$scope', '$window', 'ConferenceCalls', 'Api', '$translate', '$q', function($scope, $window, ConferenceCalls, Api, $translate, $q) {
				$scope.d = {};
				$scope.callerSort = {col: 'created', dir: true};

				$scope.formatByTimezone = function(date, format){
          var mm = moment(date);
          var mmTz = mm.tz($scope.user.home_time_zone) || mm;
					return mmTz.format(format);
        };

				$scope.confirmBoot = function confirmBoot() {
          return $translate('Are you sure you want to remove this caller from the call?')
            .then(
              function(text) { return text; },
              function(fallback) { return fallback; }
            ).then(function(text) {
              return $window.confirm(text) ? $q.resolve() : $q.reject();
            });
				};

        $scope.playName = function($event, url) {
          $scope.audioElement = (function(url){
            var audioElement = $scope.audioElement || $('<audio>').get(0);
            audioElement.src = url;
            audioElement.load();
            return audioElement;
          })(url);

          $scope.audioElement.play();
        };

				$scope.nameIsEditable = function() {
					return $scope.bridge && !$scope.bridge.external_pin_list;
				};

				$scope.saveCallName = function(call, name) {
          call.name = name;

					ConferenceCalls.changeCall({conferenceCallId: call.id}, {
						name: name,
					});
				};

				$scope.transferCaller = function(caller, room) {
					room = room || {};
					if(room.status === 'C') {
						return alert('Room '+room.name+' is currently closed.');
					}

					var url = '/bridges/api/v1/xfer/'+$scope.bridge.id+'/';
					url += (room.id||0)+'/';

					Api.fetchOne(url, caller.sid);

					caller.room = room.id;
				};

        $scope.isUnknownStatus = function(caller) {
          return ['ringing', 'in-progress', 'answered'].indexOf(caller.status) === -1;
        };
        $scope.isInProgress = function(caller) {
          return ['ringing', 'in-progress'].indexOf(caller.status) > -1;
        };
			}],

			link: function($scope, $el, atts) {},
		};
	}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/callers-table/callers-table.directive.js
 ** module id = 325
 ** module chunks = 0
 **/